module.exports = __webpack_public_path__ + "static/media/15_sognolucido.2fecd1cd.jpg";